<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <ul style="display: flex; align-items: center">
        <text style="color: #606266">认领客户：</text>
        <el-select
          v-model="state.customer_id"
          size="large"
          disabled
          style="margin-right: 20px; width: 400px"
        >
          <el-option
            v-for="item in state.customer_data"
            :key="item"
            :value="item.id"
            :label="item.name"
          ></el-option>
          <template #footer>
            <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
          </template>
        </el-select>
        <text style="color: #606266">项目编码：</text>
        <el-input
          v-model="state.project_no"
          size="large"
          style="width: 300px"
        ></el-input>
      </ul>
      <div
        v-for="(item, index) in state.tableData"
        :key="item"
        style="width: 100%; margin-top: 20px"
      >
        <text style="font-size: 12px; font-weight: 600; line-height: 20px">
          {{ index + 1 }}.到款记录信息
        </text>
        <el-table :data="[item]" class="bankcollected-add-table" size="small">
          <el-table-column
            label="到款时间"
            prop="received_time"
            sortable="received_time"
            width="120"
            :formatter="$tab_TextFormat"
            fixed
          />
          <el-table-column label="状态/ID" width="100">
            <template #default="{ row }">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  width: fit-content;
                "
              >
                <component
                  :is="
                    $statusFormat2(
                      'bankReceived_collected_status',
                      row.collected_status,
                    )
                  "
                />
                <text
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                    text-align: center;
                  "
                >
                  {{ row.id }}
                </text>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="到账银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.bank_account?.account,
                  row.bank_account?.opening_bank || '',
                )
            "
            min-width="180"
          />
          <el-table-column
            label="付款银行"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  row.payment_name + '/' + row.payment_account,
                  row.payment_bank || '',
                )
            "
            min-width="180"
          />
          <el-table-column
            label="金额"
            prop="received_amount"
            align="right"
            :formatter="$tab_PriceFormat"
            min-width="120"
          />
          <el-table-column
            label="实际到账金额/手续费"
            align="right"
            :formatter="
              (row) =>
                $tab_GroupFormat(
                  $priceFormat(row.real_received_amount),
                  $priceFormat(row.service_fee),
                )
            "
            min-width="120"
          />
          <el-table-column
            label="已认领/未认领金额"
            min-width="120"
            align="right"
          >
            <template #default="{ row }">
              <c_tabgroup
                :value1="$priceFormat(row.collected_amount)"
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  align-items: flex-end;
                "
              >
                <template #bottom>
                  <c_money
                    :value="row.uncollected_amount"
                    style="font-weight: 600"
                  />
                </template>
              </c_tabgroup>
            </template>
          </el-table-column>
          <el-table-column label="摘要信息/认领明细" min-width="200">
            <template #default="{ row }">
              <div>
                <ul>
                  {{
                    row.customer_name || "-"
                  }}
                </ul>
                <ul
                  v-if="row.collected_amount_detail?.collected"
                  style="
                    color: #a2a2a2;
                    font-size: var(--tab-group-second-font-size);
                  "
                  v-html="
                    Object.keys(row.collected_amount_detail?.collected)
                      .map(
                        (key) =>
                          `${key}: <text style='color:#ffa500;margin-right:5px'>${$priceFormat(
                            row.collected_amount_detail?.collected[key],
                          )}</text>`,
                      )
                      .join(' ')
                  "
                ></ul>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="认领明细"
            width="120"
            align="center"
            fixed="right"
            className="tabBtn"
          >
            <template #default="{ row }">
              <el-button
                type="primary"
                link
                icon="Edit"
                @click="
                  state.selectItem = row;
                  state.showDetail = true;
                "
                :disabled="!state.customer_id"
              >
                编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-if="item.bank_received_data?.length > 0">
          <text
            style="
              font-size: 12px;
              font-weight: 600;
              line-height: 20px;
              color: #ffa500;
            "
          >
            认领明细
          </text>
          <div
            style="
              background-color: #fff;
              padding-top: -2px;
              overflow: hidden;
              width: 100%;
              font-size: 80%;
            "
            class="bankcollected-add-div"
          >
            <table
              style="
                width: 100%;
                border-collapse: collapse;
                border-color: var(--el-border-color-lighter);
                border-left: 0;
                table-layout: fixed;
              "
              cellpadding="10"
              border="1"
            >
              <tbody>
                <tr>
                  <td class="bankcollected-add-first-td">
                    <span style="position: absolute; top: 5px; left: 10px">
                      数据
                    </span>
                    <span style="position: absolute; bottom: 5px; right: 10px">
                      用途
                    </span>
                  </td>
                  <td
                    style="
                      color: #ffa500;
                      padding: 10px 15px;
                      white-space: nowrap;
                    "
                    v-for="type in item.bank_received_data"
                    :key="type"
                  >
                    {{ type.bank_received_type }}
                  </td>
                </tr>
                <tr>
                  <td style="text-align: center; color: #a2a2a2">金额</td>
                  <td v-for="type in item.bank_received_data" :key="type">
                    {{ $priceFormat(type.collect_amount) }}
                    <!-- <el-input-number
                    v-model="type.collect_amount"
                    :precision="2"
                    :controls="false"
                    :min="type.bank_received_type == '其他' ? '-9999999' : 0"
                    style="width: 100%; border: 0"
                    class="bankcollected-add-number"
                    @blur="onAmountBlur(item)"
                  /> -->
                  </td>
                </tr>
                <tr>
                  <td style="text-align: center; color: #a2a2a2">说明</td>
                  <td v-for="type in item.bank_received_data" :key="type">
                    {{ type.collect_remark || "-" }}
                  </td>
                  <!-- <template v-for="type in item.bank_received_data" :key="type">
                  <td
                    v-if="type.bank_received_type != '其他'"
                    :style="{
                      'vertical-align':
                        type.collect_amount > 0 ? 'top' : 'middle',
                      border:
                        type.collect_amount > 0 && !type.collect_remark
                          ? '1px solid #f00'
                          : '',
                    }"
                    :title="type.collect_remark"
                  >
                    <el-input
                      v-model="type.collect_remark"
                      class="bankcollected-add-textarea"
                      type="textarea"
                      resize="none"
                      align="center"
                      :autosize="{ minRows: 2 }"
                      input-style="text-align:center"
                      v-if="type.collect_amount > 0"
                    />
                    <li
                      style="
                        text-align: center;
                        width: 100%;
                        height: 50px;
                        line-height: 50px;
                      "
                      v-else
                    >
                      -
                    </li>
                  </td>
                  <td
                    v-else
                    :style="{
                      'vertical-align':
                        Math.abs(type.collect_amount) > 0 ? 'top' : 'middle',
                      border:
                        Math.abs(type.collect_amount) > 0 &&
                        !type.collect_remark
                          ? '1px solid #f00'
                          : '',
                    }"
                    :title="type.collect_remark"
                  >
                    <el-input
                      v-model="type.collect_remark"
                      class="bankcollected-add-textarea"
                      type="textarea"
                      resize="none"
                      align="center"
                      :autosize="{ minRows: 2 }"
                      input-style="text-align:center"
                      v-if="Math.abs(type.collect_amount) > 0"
                    />
                    <li
                      style="
                        text-align: center;
                        width: 100%;
                        height: 50px;
                        line-height: 50px;
                      "
                      v-else
                    >
                      -
                    </li>
                  </td>
                </template> -->
                </tr>
                <tr>
                  <td style="text-align: center; color: #a2a2a2">工资表</td>
                  <td v-for="type in item.bank_received_data" :key="type">
                    <div
                      v-html="type.payroll_name || '-'"
                      style="
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                      "
                    ></div>
                  </td>
                  <!-- <td
                  style="text-align: center; color: #606266"
                  v-for="type in item.bank_received_data"
                  :key="type"
                  :title="type.payroll_name"
                  :style="{
                    border:
                      type.collect_amount > 0 &&
                      ['工资', '个税', '服务费'].includes(
                        type.bank_received_type
                      ) &&
                      !type.payroll_id
                        ? '1px solid #f00'
                        : '',
                  }"
                >
                  <div style="min-height: 40px; padding: 5px 11px">
                    <div
                      v-if="
                        ['工资', '个税', '服务费'].includes(
                          type.bank_received_type
                        ) && type.collect_amount > 0
                      "
                      style="cursor: pointer"
                      @click="
                        state.selectItem = type;
                        state.payroll_id = type.payroll_id;
                        state.showPayroll = true;
                      "
                    >
                      <text
                        v-if="!type.payroll_id"
                        style="color: #a2a2a2; line-height: 40px"
                      >
                        请选择
                      </text>
                      <text v-else>
                        {{ type.payroll_name }}
                      </text>
                    </div>
                    <li
                      style="text-align: center; width: 100%; line-height: 40px"
                      v-else
                    >
                      -
                    </li>
                  </div>
                </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit(0)">仅提交认领</el-button>
      <el-button type="success" @click="onSubmit(1)">
        提交并同步创建子账户
      </el-button>
      <text style="margin-left: 50px"> 合计： </text>
      <c_money :value="state.totalAmount" bold size="30" :prefix="false" />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showDetail"
        title="认领明细"
        @close="state.showDetail = false"
      >
        <c_PayrollBankCollectedAddBatchDetail
          @close="
            state.showDetail = false;
            onLoad();
          "
          :customer_id="props.customer_id"
          :customer_name="state.customer_name"
          :item="state.selectItem"
          :payroll_data="state.payroll_data"
          @confirm="onDetailConfirm"
        ></c_PayrollBankCollectedAddBatchDetail>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { bankcollected_addbatch } from "@/http/bankcollected";
import { payrollemployee_bankreceived } from "@/http/payrollemployee";
import { data_customer_select } from "@/http/data";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    customer_id: Number,
    payroll_id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.customer_id = props.customer_id;

      data_customer_select().then((res) => {
        if (res.status == 200) {
          const { list } = res.data.data;
          state.customer_data = list;
          state.customer_name = list.find(
            (w) => w.id == state.customer_id,
          )?.name;
        }
      });

      payrollemployee_bankreceived({
        limit: 0,
        id: props.ids.join(","),
        customer_id: props.customer_id,
        payroll_id: props.payroll_id,
        is_more: true,
      }).then((res) => {
        if (res.status == 200) {
          const { list } = res.data.data;
          state.tableData = list;
        }
      });
    });

    const onSubmit = (is_add_customer_subaccount) => {
      let data = [];

      let error = false;
      state.tableData.forEach((e, i) => {
        if (!error) {
          if (e.bank_received_data?.length > 0) {
            const bank_received_data = e.bank_received_data
              .filter(
                (w) =>
                  (w.bank_received_type == "其他" &&
                    Math.abs(w.collect_amount) > 0) ||
                  (w.bank_received_type !== "其他" && w.collect_amount > 0),
              )
              .map((m) => {
                return {
                  bank_received_type: m.bank_received_type,
                  collect_amount: m.collect_amount,
                  payroll_id: ["工资", "个税", "服务费"].includes(
                    m.bank_received_type,
                  )
                    ? props.payroll_id
                    : "",
                  collect_remark: m.collect_remark,
                };
              });

            const totalAmount = bank_received_data.reduce((acc, cur) => {
              return (acc += parseFloat(cur.collect_amount) || 0);
            }, 0);

            if (
              parseFloat(totalAmount.toFixed(2)) >
              parseFloat(e.uncollected_amount)
            ) {
              error = true;
              ElMessage.warning(
                `第${i + 1}条到款记录认领金额超出到款记录未认领金额！`,
              );
              return false;
            }

            if (bank_received_data.length > 0) {
              if (
                bank_received_data.some(
                  (w) =>
                    ((w.bank_received_type == "其他" &&
                      Math.abs(w.collect_amount) > 0) ||
                      (w.bank_received_type !== "其他" &&
                        w.collect_amount > 0)) &&
                    !w.collect_remark,
                )
              ) {
                error = true;
                ElMessage.warning(
                  `第${
                    i + 1
                  }条到款记录部分用途尚未填写对应说明，请填写后再提交！`,
                );
                return false;
              }

              data.push({
                bank_received_id: e.id,
                customer_id: props.customer_id,
                project_no: state.project_no,
                bank_received_data: bank_received_data,
                is_add_customer_subaccount,
              });
            }
          }
        }
      });

      if (!error) {
        if (data.length <= 0) {
          ElMessage.warning(`请至少填写一项认领用途的认领金额！`);
          return false;
        }

        ElMessageBox.confirm(
          `本次有效认领了<strong style='color:#f00'>${data.length}</strong>条到款记录至客户<strong style='color:#080'>${state.customer_name}</strong>，是否确定提交？`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "立即提交",
            cancelButtonText: "取消",
            type: "warning",
          },
        ).then(() => {
          bankcollected_addbatch(JSON.stringify(data)).then((res) => {
            if (res.status == 200)
              ElMessageBox.alert(res.data.msg, "操作提示", {
                confirmButtonText: "确定",
                callback: () => {
                  emit("confirm");
                },
              });
          });
        });
      }
    };

    const onAmountBlur = (item, type) => {
      const totalAmount = item.bank_received_data.reduce((acc, cur) => {
        return (acc += cur.collect_amount || 0);
      }, 0);
      if (
        parseFloat(totalAmount.toFixed(2)) > parseFloat(item.uncollected_amount)
      ) {
        ElMessage.warning("当前认领金额超出到款记录未认领金额！");
        type.collect_amount = 0;
      }
    };

    const onDetailConfirm = (data) => {
      let item = state.tableData.find((w) => w.id == state.selectItem.id);
      item.bank_received_data = data;
      state.showDetail = false;
      onBuildTotal();
    };

    const onBuildTotal = () => {
      state.totalAmount = state.tableData.reduce((res, e) => {
        if (e.bank_received_data?.length > 0) {
          res += e.bank_received_data.reduce((acc, cur) => {
            if (cur.bank_received_type && cur.collect_amount) {
              acc += parseFloat(cur.collect_amount);
            }
            return acc;
          }, 0);
        }
        return res;
      }, 0);
    };

    return {
      state,
      props,
      onAmountBlur,
      onSubmit,
      onDetailConfirm,
      onBuildTotal,
    };
  },
};
</script>
<style lang="less">
.bankcollected-add-table {
  .el-scrollbar__bar.is-horizontal {
    height: 3px !important;
  }
}

.bankcollected-add-div::-webkit-scrollbar {
  width: 3% !important;
  height: 3px !important;
}

.bankcollected-add-first-td {
  width: 100px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    width: 106%;
    border-bottom: 1px solid #e2e2e2;
    transform-origin: left bottom;
    transform: rotate(-21deg);
  }
}

.bankcollected-add-number {
  .el-input__wrapper {
    box-shadow: none;
  }
}

.bankcollected-add-textarea {
  & > textarea {
    box-shadow: none;
  }

  .el-textarea__inner:focus,
  .el-textarea__inner:hover {
    box-shadow: none !important;
  }
}
</style>
